import React from 'react'
import { Flex, FlexProps } from '@workday/canvas-kit-react'

export const Centered = ({ children, ...elemProps }: FlexProps) => {
  return (
    <Flex flexDirection="row" {...elemProps}>
      <Flex.Item flex={1} />
      {children}
      <Flex.Item flex={1} />
    </Flex>
  )
}
